import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\OldGetDossierListsController::__invoke
* @see app/Http/Controllers/Dossier/OldGetDossierListsController.php
* @route '/api/dossier-list'
*/
const OldGetDossierListsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: OldGetDossierListsController.url(options),
    method: 'post',
})

OldGetDossierListsController.definition = {
    methods: ["post"],
    url: '/api/dossier-list',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\OldGetDossierListsController::__invoke
* @see app/Http/Controllers/Dossier/OldGetDossierListsController.php
* @route '/api/dossier-list'
*/
OldGetDossierListsController.url = (options?: RouteQueryOptions) => {
    return OldGetDossierListsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\OldGetDossierListsController::__invoke
* @see app/Http/Controllers/Dossier/OldGetDossierListsController.php
* @route '/api/dossier-list'
*/
OldGetDossierListsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: OldGetDossierListsController.url(options),
    method: 'post',
})

export default OldGetDossierListsController